import axios from "axios";
import { get, ref } from "firebase/database";
import { db } from "../lib/firebase";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";
import { getPathDatabaseByRole, renewToken } from "./auth";
import { LaunchError } from "../utils/errors";

const fetchPromotionalCodeByCode = async ({ code, dispatch }) => {
  const token = await dispatch(renewToken());

  const { data } = await axios({
    method: "post",
    url: `${getCloudFunctionUrl("getPromotionalCodeByCode")}/getPromotionalCodeByCode`,
    data: { code },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!data?.ok) {
    return { ok: false };
  }

  return {
    ok: true,
    data: data.data ?? null,
  };
};

/**
 * Lee agencies/{agencyID}/promotionalCode en cliente y, si existe,
 * resuelve el checkout promo vía backend (solo por code).
 */
export const fetchAgencyStripeCheckoutPromo = () => async (dispatch) => {
  try {
    const { pathAgencies } = dispatch(getPathDatabaseByRole());
    if (!pathAgencies) {
      return { ok: true, data: null };
    }

    const agencySnap = await get(ref(db, pathAgencies));
    const agencyPromoCode = agencySnap.val()?.promotionalCode;
    if (!agencyPromoCode) {
      return { ok: true, data: null };
    }

    return await fetchPromotionalCodeByCode({
      code: agencyPromoCode,
      dispatch,
    });
  } catch (error) {
    dispatch(
      LaunchError(error, false, [], {
        functionName: "fetchAgencyStripeCheckoutPromo",
        tags: { operation: "fetch_agency_stripe_checkout_promo" },
      })
    );
    return { ok: false };
  }
};
